var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuvikLogoDarkBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 408.26 266.29",
    style: {
      enableBackground: "new 0 0 408.26 266.29"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#fff}")), /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.56 123.59h16.65l31.09 82.57h-14.79l-6.52-18.43H81.67l-6.64 18.43h-14.9l31.43-82.57zm22.82 52.94-14.32-40.35h-.23l-14.79 40.35h29.34zM151.76 205.68c-3.16-1.81-5.61-4.46-7.34-7.93-1.74-3.47-2.61-7.58-2.61-12.31v-39.42h12.91v36.93c0 4.42 1.18 7.95 3.55 10.59 2.37 2.64 5.57 3.97 9.6 3.97 3.24 0 6.2-.77 8.89-2.31 2.69-1.54 4.82-3.67 6.4-6.4 1.58-2.72 2.37-5.78 2.37-9.17v-33.62h12.79v60.13h-11.25l-1.66-8.53h-.12c-2.61 3.47-5.73 6.14-9.35 7.99-3.64 1.86-7.86 2.78-12.68 2.78-4.52.02-8.35-.89-11.5-2.7zM202.04 146.03h13.5l17.53 49.25h.23l17.66-49.25h13.51l-23.22 60.13h-16.23l-22.98-60.13zM270.63 146.03h12.91v60.13h-12.91zM294.68 118.8h12.79v52.32h.12l22.51-25.1h16l-22.27 23.8 24.29 36.35h-15.05l-17.66-27.58-7.94 8.41v19.18H294.7V118.8h-.02z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M154.72 131c0-31.95 26-57.95 57.95-57.95 15.09 0 28.85 5.8 39.17 15.29-4.08-1.23-8.4-1.9-12.87-1.9-24.57 0-44.57 19.99-44.57 44.57h12.92c0-17.45 14.2-31.65 31.65-31.65 16.91 0 30.76 13.32 31.61 30.02.02.54.04 1.08.04 1.63h12.92c0-.77-.02-1.53-.06-2.29-1.22-38.02-32.5-68.58-70.81-68.58-39.08 0-70.87 31.79-70.87 70.87l12.92-.01z",
    style: {
      fill: "#8e77fb"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuvikLogoDarkBg);
export default __webpack_public_path__ + "static/media/auvik-logo-dark-bg.9a0b9180f2d381c23a4427ac5c63d9c2.svg";
export { ForwardRef as ReactComponent };